import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Company - Get All (Read)
export const GetAllMarketPriceHistory = createAsyncThunk(
  "Chnage-stock/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ChangeStock.MarketPriceHistory}?name=${
          filter?.name || ""
        }&from=${filter?.from || ""}&to=${filter?.to || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Company - Get (Read)
export const GetCompany = createAsyncThunk(
  "productmanage/app-setup/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ChangeStock.Company}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Company - Create (Add)
export const AddCompany = createAsyncThunk(
  "productmanage/app-setup/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Company.Company, data);
      return res; // The new Company object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Company - Update
export const UpdateCompany = createAsyncThunk(
  "productmanage/app-setup/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.ChangeStock.Company}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Company - Delete
export const DeleteCompany = createAsyncThunk(
  "productmanage/app-setup/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Company.Company}/${id}`);
      return id; // Return the id of the deleted Company
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Company - Status
export const StatusCompany = createAsyncThunk(
  "productmanage/app-setup/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Company.Company}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "company",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetCompany, AddCompany, UpdateCompany, DeleteCompany
      .addCase(GetAllMarketPriceHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllMarketPriceHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllMarketPriceHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetCompany.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetCompany.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetCompany.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddCompany.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddCompany.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddCompany.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateCompany.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateCompany.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (Company) => Company.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateCompany.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteCompany.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteCompany.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (Company) => Company.id !== action.payload.id
        ); // Remove the Company with the deleted id
      })
      .addCase(DeleteCompany.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusCompany.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusCompany.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (Company) => Company.id !== action.payload.id
        ); // Remove the Company with the deleted id
      })
      .addCase(StatusCompany.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
